import ImageCta from './ImageCta';

export { type ImageCtaProps } from './ImageCta';
export default ImageCta;
